import { get } from './api';
import type { Service, ServiceDetail, ListServicesParams } from '../types/api';

export async function listServices(params?: ListServicesParams): Promise<Service[]> {
  const searchParams = new URLSearchParams();
  if (params?.audience) {
    searchParams.append('audience', params.audience);
  }
  if (params?.lang) {
    searchParams.append('lang', params.lang);
  }
  const queryString = searchParams.toString();
  return get<Service[]>(`/services${queryString ? `?${queryString}` : ''}`);
}

export async function getServiceBySlug(slug: string, lang?: string): Promise<ServiceDetail> {
  const searchParams = new URLSearchParams();
  if (lang) {
    searchParams.append('lang', lang);
  }
  const queryString = searchParams.toString();
  return get<ServiceDetail>(`/services/${slug}${queryString ? `?${queryString}` : ''}`);
}
